<button class="bug-report" (click)="openFeedbackModal()">
  <app-icon name="bug-report"></app-icon>
</button>
